module.exports = __webpack_public_path__ + "7822efaf36a1e90c81b14149f2a130b8.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/500_r_40.mp3
// module id = 429
// module chunks = 0